export const defaultLanguageJSON = {
   action_capture_aadhar: "Click here to capture Aadhaar card",
   action_capture_backside_aadhar: "Click here to capture backside of Aadhaar card",
   action_capture_backside_dl: "Click here to capture backside of Driving license",
   action_capture_backside_id: "Click here to capture the backside of the ID",
   action_capture_backside_pan: "Click here to capture backside of Pan card",
   action_capture_backside_ration_card: "Click here to capture backside of Ration card",
   action_capture_backside_voter_id: "Click here to capture backside of Voter ID card",
   action_capture_dl: "Click here to capture Driving license",
   action_capture_pan: "Click here to capture Pan card",
   action_capture_photoid: "Click here to capture Photo with ID",
   action_capture_ration_card: "Click here to capture Ration card",
   action_capture_selfie: "Click here to capture selfie",
   action_capture_voter_id: "Click here to capture Voter ID card",
   action_cature_video: "Click here to capture Video",
   action_dont_have_documents: "I don't have documents",
   action_have_documents: "Yes, I have documents",
   action_next: "Next",
   action_retake_aadhar: "Retake Aadhaar card",
   action_retake_address_proof: "Retake Address proof",
   action_retake_back_side: "Retake back side",
   action_retake_dl: "Retake Driving license",
   action_retake_front_side: "Retake front side",
   action_retake_id_proof: "Retake ID Proof",
   action_retake_pan: "Retake Pan card",
   action_retake_photoid: "Retake the photo with ID",
   action_retake_ration_card: "Retake Ration card",
   action_retake_selfie: "Retake the Selfie photo",
   action_retake_video: "Retake Video",
   action_retake_voter_id: "Retake Voter ID card",
   action_send: "Send",
   action_submit: "Submit",
   action_submit_aadhar: "Submit Aadhaar card",
   action_submit_dl: "Submit Driving license",
   action_submit_for_address_proof: "Submit above document as address Proof",
   action_submit_id_proof: "Submit ID Proof",
   action_submit_pan: "Submit Pan card",
   action_submit_photoid: "Submit the Photo with ID",
   action_submit_ration_card: "Submit Ration card",
   action_submit_selfie: "Submit the Selfie photo",
   action_submit_video: "Submit the Video",
   action_submit_voter_id: "Submit Voter ID card",
   hint_confirm_atleast_one_doc: "Make sure you have one of the following documents before you start the process",
   hint_enter_phone: "Enter the phone number",
   hint_position_id: "Position your ID card in rectangle",
   hint_position_id_card: "Position ID card in the above rectangle",
   hint_position_oval: "Postion your face in the circle",
   hint_start_recording: "Click here to start recording",
   hint_stop_recording: "Click here to Stop recording",
   hint_working_camera: "Make sure your camera is working",
   label_aadhar: "Aadhaar card",
   label_address_proof: "Any one valid address proof",
   label_back_camera: "back camera",
   label_backside: "Backside",
   label_dl: "Driving license",
   label_front_camera: "front camera",
   label_front_side: "Front side",
   label_id_proof: "Any one valid photo ID",
   label_pan: "Pan card",
   label_ration_card: "Ration card",
   label_video: "video",
   label_voter_id: "Voter ID card",
   option_available: "Yes, I am available at the address",
   option_discard_verification: "I don't want to do verification",
   option_document_needed:
      "I'm not present at the address. I would like to know the documents needed before I forward this link to my parents.",
   option_left_job: "I have Ieft the job, no need for verification",
   option_nobody_resides: "No, It is my address but nobody resides at this address.",
   option_not_available: "No, I am not available at the address",
   option_not_aware: "I'm not aware of the required address verification for the job",
   option_not_decided: "I haven't decided yet if I want to join this company",
   option_photoid_correct_cover: "Cover full face and ID",
   option_photoid_correct_focus: "Photo should be clear",
   option_photoid_correct_position: "Hold ID in correct position",
   option_photoid_incorrect_cover: "Don't cover ID proof",
   option_photoid_incorrect_focus: "Keep camera focused on your face and ID",
   option_photoid_incorrect_phone: "Don't capture phone ID",
   option_selfie_correct_cover: "Cover Full Face",
   option_selfie_correct_focus: "Keep camera focused",
   option_selfie_correct_position: "Position yourself at appropriate distance ",
   option_selfie_incorrect_group: "Don't take selfie with group",
   option_selfie_incorrect_mirror: "Mirror selfies are not allowed",
   option_selfie_incorrect_sunglasses: "Avoid Sunglasses while taking selfies",
   option_shifted: "I have shifted from this address.",
   sms_behalf:
      "On behalf of <%<candidateName>%>, We are from <%<providerOrg>%>. <%<requestingOrg>%> has requested to verify your address from us. Click on the link to proceed <link>",
   sms_self:
      "Dear <%<candidateName>%>, We are from <%<providerOrg>%>. <%<requestingOrg>%> has requested to verify your address from us. Click on the link to proceed <link>",
   subtitle_correct_ways: "Correct ways",
   subtitle_incorrect_ways: "Incorrect ways",
   subtitle_info_documents: "Make sure you have following documents before you start the verification",
   subtitle_no_verification: "Why you don't want to do verification?",
   subtitle_phone_behalf:
      "Enter the phone number of someone at home who can verify your address and make sure they have following documents",
   subtitle_preview_example_video: "Preview of example video",
   subtitle_review_information: "Review the information once before submission",
   subtitle_select_address_proof: "Select any one of the following document as address proof",
   subtitle_select_not_at_address: "Select the reason why you are not present at the given address",
   subtitle_submit_document: "Submit any one of the following document",
   subtitle_verify_address: "Verify your address from your home",
   text_available_address: "Are you available at the given address?",
   text_capture_back_side: "Capture the backside of the document if address is missing on front side of document",
   text_process_complete_note: "Someone from <%<providerOrg>%> may get in touch with you if we need any more details",
   text_role_explain:
      "This link is from <%<providerOrg>%>. <%<requestingOrg>%> has requested to verify your address from us. Please follow the steps to complete the verification.",
   text_thankyou: "Thank you!",
   title_address_proof: "Address Proof",
   title_address_verification: "Address Verification",
   title_home_video: "Home tour video",
   title_id_proof: "ID Proof",
   title_instructions: "Instructions",
   title_photoid: "Photo with ID",
   title_preview: "Preview",
   title_select_langauge: "Select your language",
   title_selfie_photo: "Selfie Photo",
   title_allow_permission: "Allow OnGrid to access following permissions",
   subtitle_allow_permission: "The app require access to permissions for verification",
   label_location_permission: "Location Access",
   label_camera_permission: "Camera Access",
   label_permission_deny:
      "You cannot proceed without giving permissions, please go to setting to allow permission to proceed",
   label_browser_not_supported: "Browser not supported",
   label_desktop_not_supported: "We don't support desktop browsers for this app, please use a smartphone device",
   label_ios_unsupported_browser: "Please use Safari browser on IOS devices",
   label_browser_capability_not_supported:
      "Your browser does not support location or camera, please use Chrome browser",
   label_ie_not_supported: "We do not support IE browser, please use Chrome browser",
   label_click_to_copy_url: "Click to copy url",
   action_allow: "Allow",
   text_open_link_ready: "You can open the link when you are ready with the documents",
   subtitle_incorrect_ways_home_image: "Incorrect ways to take home photo",
   incorrect_home_image_suggestion_1: "Don't take photo from inside",
   incorrect_home_image_suggestion_2: "Don't take photo from distance",
   incorrect_home_image_suggestion_3: "Don't take photo of whole building, if apartment",
   subtitle_correct_ways_home_image: "Correct ways to take home photo",
   correct_home_image_suggestion_1: "Front face of home",
   correct_home_image_suggestion_2: "Just outside the main gate",
   correct_home_image_suggestion_3: "Main door in case of apartment",
   action_capture_home_image: "Click here to capture home image",
   title_home_photo: "Home Photo",
   action_retake_home_image: "Retake the home photo",
   action_submit_home_image: "Submit the home photo",
   label_other_document: "Other ID document",
   action_capture_other: "Click here to capture Document",
   action_retake_other: "Retake Document",
   action_submit_other: "Submit Document",
   action_capture_backside_other: "Click here to capture backside of Document",
};

export const PROOF_TYPE = {
   PAN: "pan",
   RATION: "ration",
   AADHAAR: "aadhaar",
   VID: "vid",
   DL: "dl",
   OTHER: "other",
};

export const PROOF_KEYS = {
   LABEL_PAN: "label_pan",
   LABEL_RATION_CARD: "label_ration_card",
   LABEL_AADHAR: "label_aadhar",
   LABEL_VOTER_ID: "label_voter_id",
   LABEL_DL: "label_dl",
   LABEL_OTHER: "label_other_document",
   RETAKE_PAN: "action_retake_pan",
   RETAKE_RATION_CARD: "action_retake_ration_card",
   RETAKE_AADHAR: "action_retake_aadhar",
   RETAKE_VOTER_ID: "action_retake_voter_id",
   RETAKE_DL: "action_retake_dl",
   RETAKE_OTHER: "action_retake_other",
   CAPTURE_PAN: "action_capture_pan",
   CAPTURE_RATION_CARD: "action_capture_ration_card",
   CAPTURE_AADHAR: "action_capture_aadhar",
   CAPTURE_VOTER_ID: "action_capture_voter_id",
   CAPTURE_DL: "action_capture_dl",
   CAPTURE_OTHER: "action_capture_other",
   SUBMIT_PAN: "action_submit_pan",
   SUBMIT_RATION_CARD: "action_submit_ration_card",
   SUBMIT_AADHAR: "action_submit_aadhar",
   SUBMIT_VOTER_ID: "action_submit_voter_id",
   SUBMIT_DL: "action_submit_dl",
   SUBMIT_OTHER: "action_submit_other",
   CAPTURE_BACKSIDE_PAN: "action_capture_backside_pan",
   CAPTURE_BACKSIDE_RATION_CARD: "action_capture_backside_ration_card",
   CAPTURE_BACKSIDE_AADHAR: "action_capture_backside_aadhar",
   CAPTURE_BACKSIDE_VOTER_ID: "action_capture_backside_voter_id",
   CAPTURE_BACKSIDE_DL: "action_capture_backside_dl",
   CAPTURE_BACKSIDE_OTHER: "action_capture_backside_other",
};

export const proofLabelMapping = {
   [PROOF_TYPE.PAN]: PROOF_KEYS.LABEL_PAN,
   [PROOF_TYPE.RATION]: PROOF_KEYS.LABEL_RATION_CARD,
   [PROOF_TYPE.AADHAAR]: PROOF_KEYS.LABEL_AADHAR,
   [PROOF_TYPE.VID]: PROOF_KEYS.LABEL_VOTER_ID,
   [PROOF_TYPE.DL]: PROOF_KEYS.LABEL_DL,
   [PROOF_TYPE.OTHER]: PROOF_KEYS.LABEL_OTHER,
};

export const proofRetakeMapping = {
   [PROOF_TYPE.PAN]: PROOF_KEYS.RETAKE_PAN,
   [PROOF_TYPE.RATION]: PROOF_KEYS.RETAKE_RATION_CARD,
   [PROOF_TYPE.AADHAAR]: PROOF_KEYS.RETAKE_AADHAR,
   [PROOF_TYPE.VID]: PROOF_KEYS.RETAKE_VOTER_ID,
   [PROOF_TYPE.DL]: PROOF_KEYS.RETAKE_DL,
   [PROOF_TYPE.OTHER]: PROOF_KEYS.RETAKE_OTHER,
};

export const proofCaptureMapping = {
   [PROOF_TYPE.PAN]: PROOF_KEYS.CAPTURE_PAN,
   [PROOF_TYPE.RATION]: PROOF_KEYS.CAPTURE_RATION_CARD,
   [PROOF_TYPE.AADHAAR]: PROOF_KEYS.CAPTURE_AADHAR,
   [PROOF_TYPE.VID]: PROOF_KEYS.CAPTURE_VOTER_ID,
   [PROOF_TYPE.DL]: PROOF_KEYS.CAPTURE_DL,
   [PROOF_TYPE.OTHER]: PROOF_KEYS.CAPTURE_OTHER,
};

export const proofSubmitMapping = {
   [PROOF_TYPE.PAN]: PROOF_KEYS.SUBMIT_PAN,
   [PROOF_TYPE.RATION]: PROOF_KEYS.SUBMIT_RATION_CARD,
   [PROOF_TYPE.AADHAAR]: PROOF_KEYS.SUBMIT_AADHAR,
   [PROOF_TYPE.VID]: PROOF_KEYS.SUBMIT_VOTER_ID,
   [PROOF_TYPE.DL]: PROOF_KEYS.SUBMIT_DL,
   [PROOF_TYPE.OTHER]: PROOF_KEYS.SUBMIT_OTHER,
};

export const proofCaptureBacksideMapping = {
   [PROOF_TYPE.PAN]: PROOF_KEYS.CAPTURE_BACKSIDE_PAN,
   [PROOF_TYPE.RATION]: PROOF_KEYS.CAPTURE_BACKSIDE_RATION_CARD,
   [PROOF_TYPE.AADHAAR]: PROOF_KEYS.CAPTURE_BACKSIDE_AADHAR,
   [PROOF_TYPE.VID]: PROOF_KEYS.CAPTURE_BACKSIDE_VOTER_ID,
   [PROOF_TYPE.DL]: PROOF_KEYS.CAPTURE_BACKSIDE_DL,
   [PROOF_TYPE.OTHER]: PROOF_KEYS.CAPTURE_BACKSIDE_OTHER,
};

export const USER_DENIED_LOCATION_CODE = 1;

export const USER_DENIED_MEDIA = "NotAllowedError";

export const candidateVerificationAvailability = {
   AVAILABLE: "available",
   NOT_AVAILABLE: "not_available",
   NOT_INTERESTED: "not_interested",
};

export const candidateVerificationNotAvailableReason = {
   NOBODY_RESIDES: "nobody_resides",
   SHIFTED: "shifted",
   FORWARD_TO_PARENTS: "forward_to_parents",
};

export const candidateVerificationNotInterestedReason = {
   NOT_AWARE: "not_aware",
   ASSOCIATION_UNCERTAIN: "association_uncertain",
   LEFT_JOB: "left_the_job",
};
